/* eslint-disable no-nested-ternary */
import React, { useContext } from 'react';
import { readonly } from '@mummssoftware/utils/constants';
import NoteInput from './NoteInput';
import NoteList from './NoteList';
import OrderAddendum from './OrderAddendum';
import { Context } from '../../context';

const Notes = () => {
  const { view, readOnly, appendToOrder, appendOrder } = useContext(Context);
  // view is readonly when MANIFEST sets it
  const isReadOnly = view === readonly || readOnly;

  if (appendToOrder && appendOrder) {
    return <OrderAddendum />;
  }

  return (
    <>
      <NoteList />
      {!isReadOnly && <NoteInput />}
    </>
  );
};

export default Notes;
